import React, { useEffect, useState } from "react";

// REDUX
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import FiscalDataForm from "../fiscal/FiscalDataForm";
import Stack from "@mui/material/Stack";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { GreyButton } from "../styled";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import ItemFiscalDataForm from "../itemMenu/fiscal/ItemFiscalDataForm";
import { ButtonSuccessNoShadow } from "../styled/button";
import {
  getDeliveryCenterConfig,
  setDeliveryCenterConfig,
} from "../../api/DeliveryCenter/deliveryCenter";
import {
  cfopFrame,
  cofins_situacao_tributaria_frame,
  icms_origem_frame,
  icms_situacao_tributaria_frame,
  pis_situacao_tributaria_frame,
} from "../../common/frames";
import { dispatchSnackBarMessage } from "../../utils/snackbar";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {
  AnimatedModal,
  ModalContent,
  ModalHeader,
} from "../modals/AnimatedModal";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ReceiptIcon from "@mui/icons-material/Receipt";

export default function FiscalDataModal({
  show,
  closeModal,
  addressId,
  cep,
  street,
  houseNumber,
  neighborhood,
  city,
  uf,
  complement,
  reference,
}) {
  const history = useHistory();

  const [tabIndex, setTabIndex] = useState(0);

  const [defaultItemName, setDefaultItemName] = useState(null);
  const [fiscal_code, setFiscalCode] = useState(null);
  const [cfop_code, setCfopCode] = useState(cfopFrame[0]);
  const [icmsSituacaoTributariaState, setIcmsSituacaoTributariaState] =
    useState(icms_situacao_tributaria_frame[0]);
  const [icmsOrigemState, setIcmsOrigemState] = useState(icms_origem_frame[0]);
  const [icmsValue, setIcmsValue] = useState(0);

  const [cofinsSituacaoTributariaState, setCofinsSituacaoTributariaState] =
    useState(cofins_situacao_tributaria_frame[0]);
  const [cofinsValue, setCofinsValue] = useState(0);

  const [pisSituacaoTributariaState, setPisSituacaoTributariaState] = useState(
    pis_situacao_tributaria_frame[0]
  );
  const [pisValue, setPisValue] = useState(0);

  const [allowDefaultFiscalItem, setAllowDefaultFiscalItem] = useState(false);
  const [
    autoFiscalTicketForOnlinePayments,
    setAutoFiscalTicketForOnlinePayments,
  ] = useState(false);

  const deliveryCenterFiscalId = useSelector(
    (state) => state.deliveryCenter.deliveryCenter?.fk_fiscal_info
  );

  useEffect(() => {
    if (!show) return;
    loadConfigs();
  }, [show]);

  const loadConfigs = async () => {
    try {
      const params = {
        config:
          "default_fiscal_infos,allow_default_fiscal_infos,auto_fiscal_ticket_for_online_payments",
      };
      const {
        data: {
          default_fiscal_infos,
          allow_default_fiscal_infos,
          auto_fiscal_ticket_for_online_payments,
        },
      } = await getDeliveryCenterConfig(params);

      if (tabIndex === 1) {
        setFiscalStates(default_fiscal_infos);
      }

      setAllowDefaultFiscalItem(allow_default_fiscal_infos);
      setAutoFiscalTicketForOnlinePayments(
        auto_fiscal_ticket_for_online_payments
      );
    } catch (err) {
      console.error(err);
      dispatchSnackBarMessage(
        "fiscal-config-load-error",
        "Erro ao carregar configurações fiscais",
        "error"
      );
    }
  };

  const setFiscalStates = (data) => {
    if (!data) return;

    const {
      fiscal_code,
      cfop,
      icms_situacao_tributaria,
      pis_situacao_tributaria,
      cofins_situacao_tributaria,
      icms_origem,
      icms_aliquota,
      pis_aliquota,
      cofins_aliquota,
      default_item_name,
    } = data;

    if (cfop) {
      const foundCfop = cfopFrame.find((frameItem) => frameItem.value === cfop);
      setCfopCode(foundCfop ?? cfopFrame[0]);
    }

    if (icms_situacao_tributaria) {
      const foundIcmsSituacaoTributaria = icms_situacao_tributaria_frame.find(
        (frameItem) => frameItem.value === icms_situacao_tributaria
      );
      setIcmsSituacaoTributariaState(
        foundIcmsSituacaoTributaria ?? icms_situacao_tributaria_frame[0]
      );
    }

    if (icms_origem) {
      const foundIcmsOrigem = icms_origem_frame.find(
        (frameItem) => frameItem.value === icms_origem
      );
      setIcmsOrigemState(foundIcmsOrigem ?? icms_origem_frame[0]);
    }

    if (icms_aliquota) {
      setIcmsValue(icms_aliquota);
    }

    if (pis_situacao_tributaria) {
      const foundPisSituacaoTributaria = pis_situacao_tributaria_frame.find(
        (frameItem) => frameItem.value === pis_situacao_tributaria
      );
      setPisSituacaoTributariaState(
        foundPisSituacaoTributaria ?? pis_situacao_tributaria_frame[0]
      );
    }

    if (pis_aliquota) {
      setPisValue(pis_aliquota);
    }

    if (cofins_situacao_tributaria) {
      const foundCofinsSituacaoTributaria =
        cofins_situacao_tributaria_frame.find(
          (frameItem) => frameItem.value === cofins_situacao_tributaria
        );
      setCofinsSituacaoTributariaState(
        foundCofinsSituacaoTributaria ?? cofins_situacao_tributaria_frame[0]
      );
    }

    if (cofins_aliquota) {
      setCofinsValue(cofins_aliquota);
    }

    if (fiscal_code) {
      setFiscalCode(fiscal_code);
    }

    if (default_item_name) {
      setDefaultItemName(default_item_name);
    }
  };

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  const handleAutoFiscalTicketChange = async (event) => {
    const newValue = event.target.checked;

    try {
      await setDeliveryCenterConfig({
        config: {
          auto_fiscal_ticket_for_online_payments: newValue,
        },
      });

      setAutoFiscalTicketForOnlinePayments(newValue);

      const successMessage = newValue
        ? "Emissão automática de notas fiscais para pagamentos online ativada com sucesso"
        : "Emissão automática de notas fiscais para pagamentos online desativada com sucesso";

      dispatchSnackBarMessage(
        "auto-fiscal-ticket-config",
        successMessage,
        "success"
      );
    } catch (error) {
      console.error(error);
      dispatchSnackBarMessage(
        "auto-fiscal-ticket-config-error",
        "Erro ao atualizar configuração de emissão automática de notas fiscais",
        "error"
      );
    }
  };

  const handleBlockDriversChange = async (event) => {
    try {
      const newCheckedValue = event.target.checked;

      const data = {
        config: {
          allow_default_fiscal_infos: newCheckedValue,
        },
      };

      await setDeliveryCenterConfig(data);
      setAllowDefaultFiscalItem(newCheckedValue);

      const successMessage = newCheckedValue
        ? "Uso do item fiscal padrão ativado com sucesso"
        : "Uso do item fiscal padrão desativado com sucesso";

      dispatchSnackBarMessage(
        "default-fiscal-item-config",
        successMessage,
        "success"
      );
    } catch (error) {
      console.error(error);
      dispatchSnackBarMessage(
        "default-fiscal-item-config-error",
        "Erro ao atualizar configuração do item fiscal padrão",
        "error"
      );
    }
  };

  const handleSaveDeliveryCenterDefaultFiscalItem = async () => {
    try {
      const data = {
        config: {
          default_fiscal_infos: {
            fiscal_code: fiscal_code,
            cfop: cfop_code.value,
            icms_situacao_tributaria: icmsSituacaoTributariaState.value,
            icms_origem: icmsOrigemState.value,
            pis_situacao_tributaria: pisSituacaoTributariaState.value,
            cofins_situacao_tributaria: cofinsSituacaoTributariaState.value,
            icms_aliquota: icmsValue,
            pis_aliquota: pisValue,
            cofins_aliquota: cofinsValue,
            default_item_name: defaultItemName,
          },
        },
      };

      await setDeliveryCenterConfig(data);

      dispatchSnackBarMessage(
        "default-fiscal-infos-save",
        "Dados fiscais padrão salvos com sucesso",
        "success"
      );
    } catch (error) {
      console.error(error);
      dispatchSnackBarMessage(
        "default-fiscal-infos-save-error",
        "Erro ao salvar dados fiscais padrão",
        "error"
      );
    }
  };

  const handleGoToFiscalTicketHistoryScreen = () => {
    history.push("/fiscal");
  };

  const renderAutoFiscalTicketConfig = () => (
    <Paper
      elevation={3}
      sx={{
        mb: 3,
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: autoFiscalTicketForOnlinePayments
          ? "success.light"
          : "grey.300",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: autoFiscalTicketForOnlinePayments
              ? "success.light"
              : "grey.200",
            color: autoFiscalTicketForOnlinePayments
              ? "success.dark"
              : "grey.600",
            borderRadius: 1.5,
            p: 0.75,
            width: 36,
            height: 36,
            mr: 2,
          }}
        >
          <ReceiptIcon fontSize="small" />
        </Box>

        <Typography variant="h6" fontWeight={500} sx={{ flexGrow: 1 }}>
          Emissão Automática de Notas Fiscais
        </Typography>

        <FormControlLabel
          control={
            <Switch
              checked={autoFiscalTicketForOnlinePayments}
              onChange={handleAutoFiscalTicketChange}
              color="success"
            />
          }
          label=""
        />
      </Box>

      <Box sx={{ ml: 7 }}>
        <Typography
          variant="subtitle1"
          fontWeight={500}
          color={
            autoFiscalTicketForOnlinePayments
              ? "success.main"
              : "text.secondary"
          }
        >
          {autoFiscalTicketForOnlinePayments ? "Ativado" : "Desativado"}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {autoFiscalTicketForOnlinePayments
            ? "Notas fiscais serão emitidas automaticamente para pedidos com pagamento online confirmado."
            : "Notas fiscais não serão emitidas automaticamente para pagamentos online."}
        </Typography>
      </Box>
    </Paper>
  );

  return (
    <AnimatedModal
      isOpen={show}
      onClose={closeModal}
      width="60%"
      maxWidth="1000px"
    >
      <ModalHeader
        title="Módulo Fiscal"
        icon={AccountBalanceIcon}
        onClose={closeModal}
      />
      <ModalContent padding={0}>
        <Stack display="flex" justifyContent="center">
          <GreyButton
            variant="contained"
            startIcon={<PointOfSaleIcon />}
            onClick={handleGoToFiscalTicketHistoryScreen}
            sx={{ mb: 1, boxShadow: 0 }}
          >
            Histórico de Notas Fiscais
          </GreyButton>
        </Stack>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabIndex} onChange={handleTabChange}>
            <Tab label="Dados Fiscais" />
            <Tab label="Itens Fiscais" />
          </Tabs>
        </Box>

        <Box sx={{ p: 2 }}>
          {tabIndex === 0 && (
            <>
              {renderAutoFiscalTicketConfig()}

              <FiscalDataForm
                fiscalId={deliveryCenterFiscalId}
                address={{
                  addressId: addressId,
                  cep: cep,
                  street: street,
                  houseNumber: houseNumber,
                  neighborhood: neighborhood,
                  complement: complement,
                  reference: reference,
                  city: city,
                  uf: uf,
                }}
              />
            </>
          )}
          {tabIndex === 1 && (
            <>
              <Box sx={{ p: 2, borderRadius: 4, backgroundColor: "#fff" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={allowDefaultFiscalItem}
                      onChange={handleBlockDriversChange}
                    />
                  }
                  label="Permitir o uso do item fiscal padrão"
                />
              </Box>
              <TextField
                size="small"
                variant="outlined"
                id="default_item_name"
                name="default_item_name"
                label="Nome do produto na Nota Fiscal"
                fullWidth
                value={defaultItemName}
                onChange={(event) => {
                  setDefaultItemName(event.target.value);
                }}
                sx={{ my: 2 }}
              />

              <Divider>
                <Chip label="DADOS FISCAIS" />
              </Divider>

              <ItemFiscalDataForm
                fiscalCode={fiscal_code}
                setFiscalCode={setFiscalCode}
                cofinsSituacaoTributariaState={cofinsSituacaoTributariaState}
                setCofinsSituacaoTributariaState={
                  setCofinsSituacaoTributariaState
                }
                cofinsValue={cofinsValue}
                setCofinsValue={setCofinsValue}
                pisSituacaoTributariaState={pisSituacaoTributariaState}
                setPisSituacaoTributariaState={setPisSituacaoTributariaState}
                pisValue={pisValue}
                setPisValue={setPisValue}
                icmsOrigemState={icmsOrigemState}
                setIcmsOrigemState={setIcmsOrigemState}
                icmsSituacaoTributariaState={icmsSituacaoTributariaState}
                setIcmsSituacaoTributariaState={setIcmsSituacaoTributariaState}
                icmsValue={icmsValue}
                setIcmsValue={setIcmsValue}
                cfopCode={cfop_code}
                setCfopCode={setCfopCode}
                isDefaultItemConfig
              />

              <ButtonSuccessNoShadow
                fullWidth
                onClick={handleSaveDeliveryCenterDefaultFiscalItem}
                sx={{ mb: 2 }}
              >
                Salvar
              </ButtonSuccessNoShadow>
            </>
          )}
        </Box>
      </ModalContent>
    </AnimatedModal>
  );
}
